import { PURCHASES } from "../../types/PurchaseType";

import axios from "axios";
import moment from "moment";

const getPurchaseAction = (data) => {
	return {
		type: PURCHASES,
		payload: data,
	};
};

const formatQueryDate = (value, fallback) => {
	if (!value) return fallback;
	if (typeof value === "object" && value.format) {
		return moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : fallback;
	}
	const parsed = moment(value);
	return parsed.isValid() ? parsed.format("YYYY-MM-DD") : fallback;
};

export const loadAllPurchase = ({ page, limit, startdate, enddate, supplier }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const startDateISO = formatQueryDate(startdate, moment().startOf("month").format("YYYY-MM-DD"));
			const endDateISO = formatQueryDate(enddate, moment().endOf("month").format("YYYY-MM-DD"));
			const supplierParam =
				supplier != null && supplier !== ""
					? `&supplier=${encodeURIComponent(supplier)}`
					: "";

			const { data } = await axios.get(
				`purchase-invoice?&page=${page}&count=${limit}&startdate=${startDateISO}&enddate=${endDateISO}${supplierParam}`
			);
			//dispatching data
			dispatch(getPurchaseAction(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};
